export default __webpack_public_path__ + "static/media/taami-mikra.b8777861.png";